import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "custom-tree-node" }
const _hoisted_2 = {
  class: "node-content",
  style: {"display":"flex","align-items":"center"}
}
const _hoisted_3 = {
  class: "custom-control custom-checkbox d-inline-block",
  style: {"margin-left":"4px"}
}
const _hoisted_4 = ["id", "checked", "disabled", "indeterminate"]
const _hoisted_5 = ["for"]
const _hoisted_6 = {
  class: "node-children",
  style: {"padding-left":"28px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CustomTreeNode = _resolveComponent("CustomTreeNode", true)!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "toggle-icon2 user-select-none2",
        onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleExpand && _ctx.toggleExpand(...args)), ["stop"])),
        style: _normalizeStyle({ visibility: _ctx.hasChildren ? 'visible' : 'hidden' })
      }, [
        _createElementVNode("i", {
          class: _normalizeClass(_ctx.expandedIconClass)
        }, null, 2)
      ], 4),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("input", {
          type: "checkbox",
          class: "form-check-input me-1",
          id: `checkbox-${_ctx.node.id}`,
          checked: _ctx.isChecked,
          disabled: _ctx.isDisabled,
          onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onCheckChange && _ctx.onCheckChange(...args))),
          indeterminate: _ctx.isIndeterminate
        }, null, 40, _hoisted_4),
        _createElementVNode("label", {
          class: "form-check-label",
          for: `checkbox-${_ctx.node.id}`,
          style: {"user-select":"none","cursor":"pointer"}
        }, _toDisplayString(_ctx.node[_ctx.fields.text]), 9, _hoisted_5)
      ])
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_6, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.node.children, (child) => {
        return (_openBlock(), _createBlock(_component_CustomTreeNode, {
          ref_for: true,
          ref: "childrenRefs",
          key: child.id,
          node: child,
          fields: _ctx.fields,
          selectedNodes: _ctx.selectedNodes,
          disabledNodes: _ctx.disabledNodes,
          onCheckChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('check-change', $event)))
        }, null, 8, ["node", "fields", "selectedNodes", "disabledNodes"]))
      }), 128))
    ], 512), [
      [_vShow, _ctx.isExpanded && _ctx.hasChildren]
    ])
  ]))
}